import React from 'react';
import styled from '@emotion/styled';
import { WarningIcon } from '../Icons/newIcons/WarningIcon';
import { __ } from '../../helpers/TranslationService';

const SoldOutContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: ${({ theme }) => theme.text.color.primary};
    line-hight: 22px;
`;
const StyledWarnningIcon = styled(WarningIcon)`
    fill: ${({ theme }) => theme.colors.heatWave[100]};
    height: 16px;
    width: 16px;
    flex-shrink: 0;
`;
const SoldOutSubText = styled.p`
    margin-bottom: 0;
    margin-top: 16px;
`;
const SoldOutWarnning = styled.div`
    border: 2px solid ${({ theme }) => theme.colors.heatWave[20]};
    background: ${({ theme }) => theme.colors.heatWave[4]};
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 6px;
`;

const SoldOutTitle = styled.h4`
    font-size: 14px;
    margin: 0;
    padding: 0;
    font-weight: 700;
    line-height: 22px;
`;
const SoldOutMessage = styled.p`
    margin: 0;
`;
type Props = {
    soldOut?: string;
};
export const RequestFormSoldOut = ({ soldOut }: Props) => (
    <SoldOutContainer data-testid="request-form-sold-out-new">
        <SoldOutWarnning>
            <StyledWarnningIcon />
            <div>
                <SoldOutTitle>
                    {soldOut
                        ? __('request.soldOutSailMessage', 'dreamlines')
                        : __('request.notAvailableColumn.header', 'dreamlines')}
                </SoldOutTitle>
                <SoldOutMessage>
                    {soldOut
                        ? __('request.soldOutSubText', 'dreamlines')
                        : __('request.notAvailableColumn.subHeadline', 'dreamlines')}
                </SoldOutMessage>
            </div>
        </SoldOutWarnning>

        <SoldOutSubText>
            {soldOut
                ? __('request.soldOutContactText', 'dreamlines')
                : __('request.notAvailableColumn.text', 'dreamlines')}
        </SoldOutSubText>
    </SoldOutContainer>
);
